import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createProjectExpenseType(
    data: Boundaries["createProjectExpenseType"]["request"],
  ): void;
}

function useCreateProjectExpenseType(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateProjectExpenseTypeRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateProjectExpenseTypeRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateProjectExpenseTypeRequestFailure,
    ),
    createProjectExpenseType: core.createProjectExpenseType,
  };
}

export { useCreateProjectExpenseType };
